const downloadFile = (blob, filename = 'newFile.txt') => {
  if (navigator.msSaveBlob)
      navigator.msSaveBlob(blob, filename);
  else {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
  }
}
export default downloadFile